<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>设备管理</el-breadcrumb-item>
        <el-breadcrumb-item>告警类型</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="warp-main">
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="filters" ref="filtersForm">
          <el-form-item label="告警类型名称" prop="name">
            <el-input v-model="filters.name" placeholder="告警类型名称"></el-input>
          </el-form-item>
          <el-form-item label="告警类型编码" prop="code">
            <el-input v-model="filters.code" placeholder="告警类型编码"></el-input>
          </el-form-item>
           <el-form-item label="设备供应商">
             <el-select  v-model="filters.supplierId" placeholder="设备供应商" clearable style="width:300px;" clearable>
                <el-option v-for='(item,index) in allSupplier' :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="玉平告警大类">
                <el-select  v-model="filters.ypEventTypeId" placeholder="玉平告警大类" style="width:300px;"  clearable>
                    <el-option v-for='(item,index) in ypEventTypes' :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button type="primary" @click="resetForm('filtersForm')">重置</el-button>
            <el-button type="primary" @click="showAddDialog" v-has-permission="'device:event:dictionary:add'">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table :data="eventDicts" highlight-current-row border style="width: 100%;">
        <el-table-column type="index" label="序号" width="60" align="center" fixed="left"></el-table-column>
        <el-table-column prop="name" label="告警事件名称" width="200" fixed="left" align="center"></el-table-column>
        <el-table-column prop="code" label="告警编码" width="100" fixed="left" align="center"></el-table-column>
        <el-table-column prop="deviceSupplierName" label="供应商"  fixed="left" width="250"  align="center"></el-table-column>
        <el-table-column prop="ypEventTypeName" label="玉平告警大类" width="250"  align="center"></el-table-column>
        <el-table-column prop="ypEventTypeParentName" label="大类父类" width="250"  align="center"></el-table-column>
        <el-table-column prop="remark" label="描述" width="550" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="200" align="center" ></el-table-column>
        <el-table-column prop="updateDate" label="更新时间" width="200" align="center" ></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="200" >
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="showEditDialog(scope.$index,scope.row)" style="margin-left:0" v-has-permission="'device:event:dictionary:update'">编辑</el-button>
            <el-button type="" size="mini" @click="eventRule(scope.$index,scope.row)" style="margin-left:0" >规则</el-button>
            <el-button type="danger" size="mini" @click="remove(scope.$index,scope.row)" style="margin-left:0" v-has-permission="'device:event:dictionary:delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页工具栏-->
      <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
          :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
      </el-col>

      <!--新增编辑界面-->
      <el-dialog :title="title" :visible.sync="addFormVisible" :close-on-click-modal="false" :before-close="closeChangeMachie" width="600px">
        <el-form :model="addForm" label-width="120px" :rules="formRules" ref="addForm">
            <el-input v-model="addForm.id" type="hidden"></el-input>
          <el-row>
            <el-col :span="24">
              <el-form-item label="设备供应商" prop="deviceSupplierId">
                <el-select  v-model="addForm.deviceSupplierId" placeholder="设备供应商" style="width:440px;">
                    <el-option v-for='(item,index) in allSupplier' :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="玉平告警大类" prop="ypEventTypeId">
                <el-select  v-model="addForm.ypEventTypeId" placeholder="玉平告警大类" style="width:440px;">
                    <el-option v-for='(item,index) in ypEventTypes' :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="类型名称" prop="name">
                <el-input v-model.trim="addForm.name" placeholder="请输入内容" maxlength="50" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="类型编码" prop="code">
                <el-input v-model.trim="addForm.code" placeholder="请输入内容" maxlength="50" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="推送标识" prop="pushFlg">
                <el-switch
                  v-model.trim="addForm.pushFlg"
                  active-text="是"
                  inactive-text="否">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="显示颜色" prop="colorValue">
                <el-color-picker v-model="addForm.colorValue"></el-color-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="描述" prop="description">
                <el-input type="textarea" v-model="addForm.remark" :rows="5" placeholder="请输入内容" maxlength="100" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false;$refs['addForm'].resetFields();">取消</el-button>
          <el-button type="primary" @click.native="addForm.submit" :loading="loading">提交</el-button>
        </div>
      </el-dialog>

      <!--显示告警规则-->
      <el-dialog :title="ruleTitle" :visible.sync="ruleVisible" :close-on-click-modal="false" width="80%">
        <el-button type="primary" size="mini" style="margin-bottom:10px;" @click="addRule">添加规则</el-button>
        <el-table :data="ruleData" highlight-current-row border style="width: 100%;">
          <el-table-column type="index" label="序号" width="60" align="center" fixed="left"></el-table-column>
          <el-table-column prop="symbolName" label="规则符号" width="200" align="center"></el-table-column>
          <el-table-column prop="value" label="值" width="160"  align="center"></el-table-column>
          <el-table-column prop="description" label="提示内容" align="center"></el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="180" >
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="updateRule(scope.$index,scope.row)">编辑</el-button>
              <el-button type="danger" size="mini" @click="deleteRule(scope.$index,scope.row)">删除</el-button>
            </template>
          </el-table-column>
      </el-table>
      </el-dialog>
      <!---编辑规则-->
      <el-dialog :title="eidtRuleTitle" :visible.sync="editRuleVisible" :close-on-click-modal="false" width="600">
        <el-form :model="ruleForm" label-width="100px" :rules="ruleFormRules" ref="ruleForm">
          <el-row>
            <el-col :span="24">
              <el-form-item label="规则符号" prop="symbol">
                <el-select  v-model="ruleForm.symbol" placeholder="规则符号" style="width:460px;">
                    <el-option v-for='(item,index) in ruleCombox' :key="index" :label="item.name" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="值" prop="value">
                <el-input v-model.trim="ruleForm.value" placeholder="请输入值" maxlength="50" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="提示内容" prop="description">
                <el-input type="textarea" v-model="ruleForm.description" :rows="5" placeholder="请输入提示内容" maxlength="255" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editRuleVisible = false;$refs['ruleForm'].resetFields();">取消</el-button>
          <el-button type="primary" @click.native="ruleForm.submit" :loading="loading">提交</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>
<script>
import API from '../../api/device/api_deviceEventDictionary';

export default {
  data() {
    var checkCode = (rule, value, callback) => {
      let that = this;
      if (!value || value === '') {
        callback(new Error('请输入告警编码'));
        return;
      }
      var params = {
        id:that.addForm.id,
        supplierId:that.addForm.deviceSupplierId,
        code: value
      }
      API.checkcode(params)
      .then(
        function(result) {
            console.log(result);
          if (result && result.code == 200 && !result.data) {
              callback(new Error('设备告警类型编码重复'));
              return;
          }
          callback();
        },
        function(error) {
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
          callback();
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
        callback();
      });
    };

    return {
      loading: false,
      allSupplier:[],
      ypEventTypes:[],
      title:"新增",
      ruleTitle:"告警规则列表",
      ruleVisible:false,
      ruleData:[],
      eidtRuleTitle:"修改规则",
      editRuleVisible:false,
      ruleCombox:[],
      ruleForm:{symbol:'',value:'',description:'',addRule:function(){}},
      eventDictId:'',
      ruleFormRules:{
        symbol:[
           {required: true, message: '请选择规则符号', trigger: ['blur','change']}
        ],
        value: [
          {required: true, message: '请输入值', trigger: ['blur','change']}
        ],
        description: [
          {required: true,message: "请输入提示内容", trigger: ['blur','change']}
        ]
      },
      filters: {
          name:"",
          code:""
      },
      // 分页参数
      total: 0,
      page: 1,
      limit: 10,
      eventDicts: [],

      // 新增/编辑相关数据
      addFormVisible: false,//新增界面是否显示
      addForm: {name:'',code:'',remark:'',pushFlg:false},
      formRules: {
        deviceSupplierId:[
           {required: true, message: '请选择设备供应商', trigger: ['blur','change']}
        ],
        ypEventTypeId:[
           {required: true, message: '请选择玉平告警大类', trigger: ['blur','change']}
        ],
        name: [
          {required: true, message: '请输入告警类型名称', trigger: ['blur','change']}
        ],
        code: [
          {required: true,validator: checkCode, trigger: ['blur','change']}
        ],
        colorValue:[
          {required: true, message: '请选择颜色', trigger: ['blur','change']}
        ]
      }
    }
  },
  methods: {
    supplierSelect:function(){
          let that = this;
          API.allSupplier({})
          .then(
              function(result) {
                console.log(result);
                if (result && result.code == 200) {
                  that.allSupplier= result.data;
                }
              },
              function(error) {
                that.$message.error({
                  showClose: true,
                  message: error.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error){
              that.$message.error({
                showClose: true,
                message: '请求出现异常',
                duration: 2000
              });
            });
    },
    //查询玉平告警大类
    getYPEventType:function(){
      let that = this;
      API.getDictCombox({code:"YPEventType"})
      .then(
          function (result) {
            console.log(result);
            if(result.code==200){
              that.ypEventTypes = result.data;
            }
          }, 
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
        })
        .catch(function (error) {
          that.loading = false;
          // console.log(error);
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.handleSearch();
    },
    search() {
      let that = this;
      let params = Object.assign({
        page: that.page,
        limit: that.limit,
      }, that.filters);
      API.getList(params)
      .then(
        function(result){
          if (result && result.code == 200) {
            that.total = result.data.total;
            that.eventDicts= result.data.records;
          }
        },
        function(error){
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
      });
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    showAddDialog: function () {
        let that = this;
        that.title='新增';
        this.addForm={};
        this.addFormVisible = true;
        this.addForm.submit=function(){
            that.$refs.addForm.validate((valid) => {
                if (valid) {
                that.loading = true;
                let params = Object.assign({}, that.addForm);
                API.insert(params)
                .then(
                    function(result){
                    that.loading = false;
                    if (result && result.code == 200 
                        && result.data && result.data === true) {
                        that.$message.success({
                        showClose: true,
                        message: '新增成功!',
                        duration: 2000
                        });
                        that.$refs['addForm'].resetFields();
                        that.addFormVisible = false;
                        that.handleSearch();
                    } else {
                        that.$message.error({
                        showClose: true,
                        message: '新增失败!',
                        duration: 2000
                        });
                    }
                    },
                    function(error){
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: error.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function(error){
                    that.loading = false;
                    that.$message.error({
                    showClose: true,
                    message: '请求出现异常!',
                    duration: 2000
                    });
                });
                }
            });
        }
    },
    //显示编辑界面
    showEditDialog: function (index, row) {
        let that = this;
        that.title='编辑';
      this.addFormVisible = true;
      //避免源对象row被修改
      var newRow = JSON.parse(JSON.stringify(row));
      this.addForm = Object.assign({}, newRow);
      console.log(this.addForm);
      this.addForm.submit=function(){
      that.$refs.addForm.validate((valid) => {
            if (valid) {
            that.loading = true;
            let params = Object.assign({}, that.addForm);
            API.update(params)
            .then(
                function(result){
                that.loading = false;
                if (result && result.code == 200 
                    && result.data && result.data === true) {
                    that.$message.success({
                    showClose: true,
                    message: '修改成功!',
                    duration: 2000
                    });
                    that.$refs['addForm'].resetFields();
                    that.addFormVisible = false;
                    that.search();
                } else {
                    that.$message.error({
                    showClose: true,
                    message: '修改失败!',
                    duration: 2000
                    });
                }
                },
                function(error){
                that.loading = false;
                that.$message.error({
                    showClose: true,
                    message: error.toString(),
                    duration: 2000
                });
                }
            )
            .catch(function(error){
                that.loading = false;
                that.$message.error({
                showClose: true,
                message: '请求出现异常!',
                duration: 2000
                });
            });
            }
        });
      }
    },
    //删除
    remove: function (index, row) {
      let that = this;
      this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
        that.loading = true;
        API.remove(row.id)
        .then(
          function (result) {
            that.loading = false;
            if (result && result.code === 200 
              && result.data && result.data === true) {
              that.$message.success({
                showClose: true,
                message: '删除成功',
                duration: 1500
              });
              that.search();
            }
          }, 
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
        })
        .catch(function (error) {
          that.loading = false;
          // console.log(error);
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
      }).catch(() => {
      });
    },
    //新增编辑窗口关闭，则关闭
    closeChangeMachie(done){
      done();
      this.$refs["addForm"].resetFields();
    },
    //规则
    eventRule:function(index,row){
      let that =this;
      that.ruleVisible=true;
      that.eventDictId=row.id;
      //查询规则列表数据
      let param={eventDictId:row.id};
      API.getRuleList(param)
      .then(
          function (result) {
            if(result.code==200){
              that.ruleData = result.data;
            }
          }, 
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
        })
        .catch(function (error) {
          that.loading = false;
          // console.log(error);
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
    },
    //新增规则
    addRule:function(){
      let that =this;
      that.ruleForm={};
      that.editRuleVisible=true;
      API.getDictCombox({code:"rule_symbols"})
      .then(
          function (result) {
            if(result.code==200){
              that.ruleCombox = result.data;
              that.ruleForm.submit=function(){
                that.$refs.ruleForm.validate((valid) => {
                  if(valid){
                    let params = Object.assign({}, that.ruleForm);
                    params.eventDictId=that.eventDictId;
                    var obj = that.ruleCombox.find((item)=>{//这里的userList就是上面遍历的数据源
                      return item.value === that.ruleForm.symbol;//筛选出匹配数据
                    });
                    params.symbolName=obj.name;
                    API.insertRule(params)
                      .then(
                          function (result) {
                            if(result.code==200){
                              //跟新数据列表中的值
                              that.editRuleVisible=false;
                              that.ruleData.push(result.data);
                            }
                          }, 
                          function (err) {
                            that.loading = false;
                            that.$message.error({
                              showClose: true,
                              message: err.toString(),
                              duration: 2000
                            });
                        })
                        .catch(function (error) {
                          that.loading = false;
                          // console.log(error);
                          that.$message.error({
                            showClose: true,
                            message: '请求出现异常',
                            duration: 2000
                          });
                        });
                  }
                });
              }
            }
          }, 
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
        })
        .catch(function (error) {
          that.loading = false;
          // console.log(error);
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
    },
    //修改规则
    updateRule:function(index,row){
      let that =this;
      that.ruleForm={};
      that.editRuleVisible=true;
      //加载符号
      API.getDictCombox({code:"rule_symbols"})
      .then(
          function (result) {
            if(result.code==200){
              that.ruleCombox = result.data;
              that.ruleForm = row;
              //绑定提交按钮
              that.ruleForm.submit=function(){
                that.$refs.ruleForm.validate((valid) => {
                  let params = Object.assign({}, that.ruleForm);
                  API.updateRule(params)
                  .then(
                      function (result) {
                        if(result.code==200){
                          //跟新数据列表中的值
                          that.editRuleVisible=false;
                          var obj = that.ruleCombox.find((item)=>{//这里的userList就是上面遍历的数据源
                                return item.value === that.ruleForm.symbol;//筛选出匹配数据
                            });
                          that.ruleForm.symbolName=obj.name;
                          that.ruleData[index]=that.ruleForm;
                        }
                      }, 
                      function (err) {
                        that.loading = false;
                        that.$message.error({
                          showClose: true,
                          message: err.toString(),
                          duration: 2000
                        });
                    })
                    .catch(function (error) {
                      that.loading = false;
                      // console.log(error);
                      that.$message.error({
                        showClose: true,
                        message: '请求出现异常',
                        duration: 2000
                      });
                    });
                });
                
              }
            }
          }, 
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
        })
        .catch(function (error) {
          that.loading = false;
          // console.log(error);
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
    }
    ,
    //删除规则
    deleteRule:function(index,row){
      let that =this;
      that.ruleForm={};
      API.deleteRule(row.id)
      .then(
          function (result) {
            if(result.code==200){
              that.ruleData.splice(index,1);
            }
            else{
              that.$message.error({
              showClose: true,
              message: result.msg,
              duration: 2000
            });
            }
          }, 
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
        })
        .catch(function (error) {
          that.loading = false;
          // console.log(error);
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
    }
  },
  mounted() {
    let that = this;
    let params = {};
    that.supplierSelect();//供应商加载
    that.getYPEventType();//加载玉平告警大类
    this.handleSearch();
  }
};
</script>


// WEBPACK FOOTER //
// deviceEventDictionary.vue?63b66ed7